import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { PRODUCT_CATEGORIES } from '../constants';
// Zap zostaje w imporcie: poza logotypem (zastąpionym przez BrandMark) używa go jeszcze podpis
// autora na dole stopki. 2026-08-12: usunięcie go „przy okazji" wywaliło CAŁĄ aplikację na
// produkcji (ReferenceError: Zap is not defined → pusty #root na każdej stronie).
import { Instagram, Facebook, Zap, Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { BrandMark } from './BrandMark';
import { trackPlausibleEvent } from '../utils/tracking';

const resourcesLinks = [
    { name: 'Biblioteka promptów AI', path: '/prompty' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'FAQ', path: '/spolecznosc/faq' },
    { name: 'Kalkulator oszczędności', path: '/edukacja/kalkulator-roi-ai' },
    { name: 'Szablony n8n', path: '/szablony-n8n' },
];

export const Footer: React.FC = () => {
  return (
    <footer className="relative bg-content-light dark:bg-content-dark overflow-hidden">
      {/* Mesh gradient background */}
      <div className="absolute inset-0 opacity-30 dark:opacity-20 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-light/20 dark:bg-primary-dark/20 rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary-light/20 dark:bg-secondary-dark/20 rounded-full filter blur-3xl" />
      </div>

      {/* Animated top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-light/50 dark:via-primary-dark/50 to-transparent" />
      <div className="absolute top-0 left-0 right-0 h-px overflow-hidden">
        <div
          className="h-full w-1/3 bg-gradient-to-r from-transparent via-primary-light dark:via-primary-dark to-transparent animate-shimmer"
          style={{ backgroundSize: '200% 100%' }}
        />
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-border-light/50 dark:border-border-dark/50">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-text-primary-light dark:text-text-primary-dark mb-4">
              {/* 2026-08-12: było „Masz konkretny cel (KPI)…" i „automatyzacja z AI może zwiększyć
                  Twoje przychody". KPI to skrót, którego odbiorca tej strony nie używa, a wzrost
                  przychodów to obietnica wyniku, na który nie mamy wpływu. Zostaje czynność, którą
                  każdy rozpozna u siebie. */}
              Co robisz ręcznie, choć nie musisz?
            </h3>
            <p className="text-text-secondary-light dark:text-text-secondary-dark mb-6">
              Napisz, co klikasz w kółko. Odpiszę, czy da się to zdjąć z głowy i ile to zajmie.
              Rozmowa jest bezpłatna, a jeśli nie warto, też to powiem.
            </p>
            <a
              href="https://wa.me/48791581239?text=Cze%C5%9B%C4%87%21%20Pisz%C4%99%20z%20biznesbezklikania.pl%20-%20chcia%C5%82bym%20um%C3%B3wi%C4%87%20bezp%C5%82atn%C4%85%20konsultacj%C4%99"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackPlausibleEvent('cta_click', { placement: 'footer' })}
              data-analytics-id="footer_cta_whatsapp"
              className="
                inline-flex items-center gap-2
                px-8 py-4
                text-lg font-semibold text-white
                bg-gradient-to-r from-primary-light to-secondary-light
                dark:from-primary-dark dark:to-secondary-dark
                rounded-2xl
                hover:shadow-xl hover:scale-[1.02]
                transition-all duration-300
                group
              "
            >
              <span>Napisz na WhatsApp → 791 581 239</span>
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>
        </div>

        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-8 lg:gap-12">

          {/* Brand Column */}
          <div className="lg:col-span-2 xl:col-span-2">
            <ReactRouterDOM.Link to="/" className="inline-flex items-center gap-3 mb-6 group">
              {/* Sygnet marki. Stała tu ta sama ikona błyskawicy z lucide-react co w nagłówku,
                  czyli zaślepka bez związku ze znakiem BBK. */}
              <BrandMark className="w-10 h-10 shrink-0 group-hover:scale-110 transition-transform" />
              <span className="text-xl font-bold text-primary-light dark:text-primary-dark">
                Biznes bez Klikania
              </span>
            </ReactRouterDOM.Link>

            <p className="text-text-secondary-light dark:text-text-secondary-dark mb-6 text-sm leading-relaxed">
              {/* 2026-08-12 USUNIĘTE: „ROI 380% gwarantowane kontraktem". Trzy problemy naraz:
                  skrót, którego odbiorca nie zna; liczba bez widocznego źródła; słowo „gwarantowane",
                  które czyni z hasła zobowiązanie umowne. Do tego stało w STOPCE, czyli na KAŻDEJ
                  podstronie. Wraca dopiero z pomiarem: u kogo, kiedy, na jakiej próbie.
                  Patrz public/brand/STANDARD-TRESCI.md. */}
              Pokazujemy, co w firmie da się przestać robić ręcznie.
              Zaczynasz od jednej czynności, którą klikasz w kółko.
            </p>

            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <a
                href="tel:+48791581239"
                className="flex items-center gap-3 text-sm text-text-secondary-light dark:text-text-secondary-dark hover:text-primary-light dark:hover:text-primary-dark transition-colors group"
              >
                <span className="w-8 h-8 rounded-lg bg-primary-light/10 dark:bg-primary-dark/10 flex items-center justify-center group-hover:bg-primary-light/20 dark:group-hover:bg-primary-dark/20 transition-colors">
                  <Phone className="w-4 h-4" />
                </span>
                <span>+48 791 581 239</span>
              </a>
              <a
                href="mailto:biznesbezklikania@gmail.com"
                className="flex items-center gap-3 text-sm text-text-secondary-light dark:text-text-secondary-dark hover:text-primary-light dark:hover:text-primary-dark transition-colors group"
              >
                <span className="w-8 h-8 rounded-lg bg-primary-light/10 dark:bg-primary-dark/10 flex items-center justify-center group-hover:bg-primary-light/20 dark:group-hover:bg-primary-dark/20 transition-colors">
                  <Mail className="w-4 h-4" />
                </span>
                <span>biznesbezklikania@gmail.com</span>
              </a>
            </div>

            {/* Social Links */}
            <div className="flex space-x-3">
              <a
                href="https://www.instagram.com/biznesbezklikania/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="
                  w-10 h-10 rounded-xl
                  bg-white/50 dark:bg-white/5
                  border border-border-light/50 dark:border-border-dark/50
                  flex items-center justify-center
                  text-text-secondary-light dark:text-text-secondary-dark
                  hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500
                  hover:text-white hover:border-transparent hover:shadow-lg hover:shadow-pink-500/25
                  transition-all duration-300
                "
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/biznesbezklikania/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="
                  w-10 h-10 rounded-xl
                  bg-white/50 dark:bg-white/5
                  border border-border-light/50 dark:border-border-dark/50
                  flex items-center justify-center
                  text-text-secondary-light dark:text-text-secondary-dark
                  hover:bg-blue-600 hover:text-white hover:border-transparent
                  hover:shadow-lg hover:shadow-blue-500/25
                  transition-all duration-300
                "
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Product Categories */}
          {PRODUCT_CATEGORIES.slice(0, 4).map(category => (
            <div key={category.name}>
              <h4 className="font-semibold mb-4 text-text-primary-light dark:text-text-primary-dark">
                {category.name}
              </h4>
              <ul className="space-y-2.5 text-sm">
                {category.products.map(service => (
                  <li key={service.title}>
                    <ReactRouterDOM.Link
                      to={service.path}
                      className="
                        text-text-secondary-light dark:text-text-secondary-dark
                        hover:text-primary-light dark:hover:text-primary-dark
                        hover:translate-x-1
                        transition-all duration-200
                        inline-block
                      "
                    >
                      {service.title}
                    </ReactRouterDOM.Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4 text-text-primary-light dark:text-text-primary-dark">
              Zasoby
            </h4>
            <ul className="space-y-2.5 text-sm">
              {resourcesLinks.map(link => (
                <li key={link.name}>
                  <ReactRouterDOM.Link
                    to={link.path}
                    className="
                      text-text-secondary-light dark:text-text-secondary-dark
                      hover:text-primary-light dark:hover:text-primary-dark
                      hover:translate-x-1
                      transition-all duration-200
                      inline-block
                    "
                  >
                    {link.name}
                  </ReactRouterDOM.Link>
                </li>
              ))}
              <li>
                <ReactRouterDOM.Link
                  to="/o-nas"
                  className="
                    text-text-secondary-light dark:text-text-secondary-dark
                    hover:text-primary-light dark:hover:text-primary-dark
                    hover:translate-x-1
                    transition-all duration-200
                    inline-block
                  "
                >
                  O nas
                </ReactRouterDOM.Link>
              </li>
              <li>
                <ReactRouterDOM.Link
                  to="/kontakt"
                  className="
                    text-text-secondary-light dark:text-text-secondary-dark
                    hover:text-primary-light dark:hover:text-primary-dark
                    hover:translate-x-1
                    transition-all duration-200
                    inline-block
                  "
                >
                  Kontakt
                </ReactRouterDOM.Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border-light/50 dark:border-border-dark/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-text-secondary-light dark:text-text-secondary-dark">
            <p>&copy; {new Date().getFullYear()} BiznesBezKlikania.pl. Wszystkie prawa zastrzeżone.</p>
            <p className="flex items-center gap-2">
              <span>Powered by</span>
              <a
                href="https://bartoszgaca.pl"
                target="_blank"
                rel="noopener noreferrer"
                className="
                  inline-flex items-center gap-1.5
                  text-primary-light dark:text-primary-dark
                  hover:underline
                  font-medium
                "
              >
                <Zap className="w-4 h-4" />
                <span>Bartosz Gaca</span>
              </a>
              <span>+</span>
              <span className="font-medium text-secondary-light dark:text-secondary-dark">G.A.C.A. AI</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
